import { ListingProductCode, type ListingProduct } from 'src/generated/graphql';

import { AccelerateFeatures } from './components/AccelerateFeatures';
import { FreemiumFeatures } from './components/FreemiumFeatures';
import { StandardFeatures } from './components/StandardFeatures';

interface FeaturesProps {
  product: ListingProduct;
}

export const Features = (props: FeaturesProps) => {
  if (props.product.productCode === ListingProductCode.Freemium) {
    return <FreemiumFeatures />;
  }

  if (props.product.productCode === ListingProductCode.ListUntilSold) {
    return <StandardFeatures />;
  }

  if (props.product.productCode === ListingProductCode.Accelerate) {
    return <AccelerateFeatures />;
  }

  return null;
};
